import {useAuth} from 'context/authContext';
import {useMutation} from 'react-query';
import {useLocation, useNavigate} from 'react-router-dom';

import {updateProfile} from 'services/wholesaler/profile';

const useEditProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {user, update} = useAuth();
  const isFarm = location.pathname.includes('farm');
  const {isLoading, mutate: editProfile} = useMutation({
    mutationFn: (payload: IUpdateProfilePayload) => {
      return updateProfile(payload);
    },
    onSuccess: data => {
      user &&
        update({
          is_registered: user?.is_registered ? user?.is_registered : false,
          message: user?.message || '',
          profile: {
            ...user.profile,
            account_type: data?.account_type,
            city: Number(data?.city),
            name: data?.name,
            state: Number(data?.state),
            profile_image: data?.profile_image || '',
          },
          token: user?.token || '',
          access_token: user?.token || '',
        });
      navigate(`/${isFarm ? 'farm' : 'wholesaler'}/account`);
    },
  });

  return {isLoading, editProfile};
};

export default useEditProfile;
